module.exports = __webpack_public_path__ + "img/TRIANGULAR.09864179.png";